<template>
    <div id="footer-root" class="footerRoot">
        <div id="footer-wrapper" class="footerWrapper">
            <div id="footer-logo-wrapper" class="footerLogoWrapper">
                <div id="logo-img-wrapper" class="logoImgWrapper">
                    <img id="logo-img" class="logoImg" :src="branding.logo" />
                </div>
                <div id="logo-text-wrapper" class="logoTextWrapper">
                    {{ branding.copyright }}
                </div>
            </div>
            <div id="footer-links-wrapper" class="footerLinksWrapper">
                <div
                    id="footer-links-inner-wrapper"
                    class="footerLinksInnerWrapper"
                >
                    <div
                        v-for="(link, index) in footerLinks"
                        :key="index"
                        :id="`footer-link_${link.path}`"
                        class="footerLink"
                        @click="onFooterClick(link.path)"
                    >
                        {{ link.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { footerList } from "@/linkLists";
import { getBranding } from "@/branding";
import { openUrl } from "@/common";

export default {
    name: "freshy-footer",
    data() {
        return {
            footerLinks: footerList,
            branding: getBranding(),
        };
    },
    mounted() {},
    methods: {
        onFooterClick(path) {
            openUrl(path, true);
        },
    },
};
</script>

<style>
@import "./footer.css";
</style>
